export default __webpack_public_path__ + "static/media/menu1.0fab7629.jpg";